import {Button, Card, CardActionArea, CardMedia, Divider, Grid, Typography} from "@mui/material";
import SvgIconBandLink from "../util/SvgIconBandLink";
import SvgIconZip from "../util/SvgIconZip";
import SvgIconSteam from "../util/SvgIconSteam";
import SvgIconVKPlay from "../util/SvgIconVKPlay";
import SvgIconRuStore from "../util/SvgIconRuStore";
import React from "react";
import {useLocale} from "../locale/Locale";
import SvgIconGooglePlay from "../util/SvgIconGooglePlay";
import SvgIconAppStore from "../util/SvgIconAppStore";

function AppGameVittaLucis() {

    const {localeText} = useLocale()

    return (
        <>
            <Grid container spacing={4}>
                <Grid item xs={12} md={6}>
                    <Card>
                        <CardActionArea
                            href={localeText('trailerVittaLucis')}
                            target="_blank"
                        >
                            <CardMedia
                                component="img"
                                image="vitta-lucis.jpg"
                                alt="Vitta Lucis"
                            />
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="h2">Vitta Lucis</Typography>
                    <Typography mb={2}>{localeText('gameVittaLucis')}</Typography>
                    <Typography>
                        <Button
                            variant="outlined"
                            color="secondary"
                            startIcon={<SvgIconSteam/>}
                            href="https://store.steampowered.com/app/3187120/Vitta_Lucis"
                            target="_blank"
                            sx={{mr: 1, mb: 1, textTransform: 'none', color: '#fff'}}
                        >
                            Steam
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            startIcon={<SvgIconVKPlay/>}
                            href="https://vkplay.ru/play/game/vitta_lucis"
                            target="_blank"
                            sx={{mr: 1, mb: 1, textTransform: 'none', color: '#fff'}}
                        >
                            VK Play
                        </Button>
                        <Button
                            disabled
                            variant="outlined"
                            color="secondary"
                            startIcon={<SvgIconRuStore/>}
                            href="/"
                            target="_blank"
                            sx={{mr: 1, mb: 1, textTransform: 'none', color: '#fff'}}
                        >
                            RuStore
                        </Button>
                        <Button
                            disabled
                            variant="outlined"
                            color="secondary"
                            startIcon={<SvgIconGooglePlay/>}
                            href="/"
                            target="_blank"
                            sx={{mr: 1, mb: 1, textTransform: 'none', color: '#fff'}}
                        >
                            Google Play
                        </Button>
                        <Button
                            disabled
                            variant="outlined"
                            color="secondary"
                            startIcon={<SvgIconAppStore/>}
                            href="/"
                            target="_blank"
                            sx={{mr: 1, mb: 1, textTransform: 'none', color: '#fff'}}
                        >
                            App Store
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            startIcon={<SvgIconBandLink/>}
                            href="https://band.link/vitta_curses_demons"
                            target="_blank"
                            sx={{mr: 1, mb: 1, textTransform: 'none', color: '#fff'}}
                        >{localeText('soundtrack')}</Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            startIcon={<SvgIconZip/>}
                            href="ISAEV-SPACE-Vitta-Lucis-Press-kit.zip"
                            target="_blank"
                            sx={{mr: 1, mb: 1, textTransform: 'none', color: '#fff'}}
                        >{localeText('pressKit')}</Button>
                    </Typography>
                </Grid>
            </Grid>
            <Divider sx={{my: 4}}/>
        </>
    )

}

export default AppGameVittaLucis
